<template>
  <section class="bg-black px-4 py-16">
    <div class="max-w-7xl mx-auto">
      <img
        :src="image"
        alt="Imagem seção"
        class="w-full lg:max-w-5xl mx-auto h-auto rounded-xl shadow-lg"
      />
    </div>
  </section>
</template>

<script>
import image from '@/assets/img5.png'

export default {
  name: 'SessaoImagemImg5',
  data() {
    return {
      image
    }
  }
}
</script>

<style scoped>
/* Nenhum estilo extra é necessário aqui */
</style>